/* eslint-disable react/prefer-es6-class, react/sort-comp */
import classnames from 'classnames';
import React from 'react';
import { t } from 'es6/services/localization';

export default React.createClass({
  displayName: 'QuizStatus',

  propTypes: {
    maxMistakes: React.PropTypes.number.isRequired,
    mistakes: React.PropTypes.number.isRequired,
  },

  render() {
    return (
      <aside className="quiz-status">
        <div className="quiz-mistakes">
          <div className="label">{t('mistakes')}</div>
          <div className="mistake-glyphs">{this._renderMistakes()}</div>
        </div>
      </aside>
    );
  },

  _renderMistakes() {
    const { mistakes, maxMistakes } = this.props;
    const mistakeComponents = [];

    for (let i = 0; i < maxMistakes; i++) {
      const className = classnames('glyph glyph-cross-sharp mistake', {
        used: (i + 1) <= mistakes,
      });

      mistakeComponents.push(<span key={i} className={className} />);
    }

    return mistakeComponents;
  },
});
